function toutou_xy_roses(myJson, fcstind, ctx) {
    // Donnees de MySQL
    var ni = myJson.hhh.length;
    var nk = myJson.levs.length;
    var force = new Array(ni);
    var dir = new Array(ni);
    var temp = new Array(ni);
    var gust = new Array(ni);
    var hhh = new Array(ni);
    var aaaammjj = myJson.aaaammjj;
    var hh = myJson.hh;
    var precip = new Array(ni);
    var my_fonts = new Toutou_Fonts();
    var tr = new Toutou_Transform();
    var deg2rad = Math.PI / 180.;
    var nroses = 3;
    var proportion = 2 / 3;
    var datev = dateo;
    uniteJson = toutou_get_option('unite_vent');
    // myJson.data1[i] = 1000*(force*10) + dir  (profil, nk niveaux)
    // myJson.data2[i] = tt_prof (température, nk niveaux)
    // myJson.data3[i] = apcpn_pr (précip accumulée, surface)
    // myJson.data4[i] = gust (rafales, surface)
    for(var i = 0; i < ni; i++){
        force[i] = new Array(nk);
        dir[i] = new Array(nk);
        temp[i] = new Array(nk);
        for(var k = 0; k < nk; k++){
            ind = nk * i + k;
            force[i][k] = Math.floor(myJson.data1[ind] / 1000.);
            dir[i][k] = myJson.data1[ind] - force[i][k] * 1000;
            force[i][k] = force[i][k] / 10. * uniteJson.conv;
            temp[i][k] = myJson.data2[ind] * .01;
        }
        gust[i] = myJson.data4[i] * uniteJson.conv;
        hhh[i] = myJson.hhh[i];
        if (i != 0) precip[i] = (myJson.data3[i] - myJson.data3[i - 1]) * .01;
        else precip[i] = 0;
    }
    // Espace autour de la boite du graphique en %
    var pil_w = .01;
    var pil_e = .01;
    var pil_s = .05;
    var pil_n = .1;
    if (ctx == undefined) ctx = set_canvas('toutou_xy_roses');
    tr.pix_margeg = Math.round(pil_w * gxsize) + .5;
    tr.pix_marged = Math.round((1. - pil_e) * gxsize) + .5;
    tr.pix_margeh = Math.round(pil_n * gysize) + .5;
    tr.pix_margeb = Math.round((1. - pil_s) * gysize) + .5;
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, gxsize, gysize);
    rose_x = Math.round((tr.pix_marged - tr.pix_margeg) / nroses);
    rose_y = Math.round((tr.pix_marged - tr.pix_margeg) / nroses / proportion);
    if (rose_y > tr.pix_margeb - tr.pix_margeh) {
        rose_y = Math.round(tr.pix_margeb - tr.pix_margeh);
        rose_x = Math.round((tr.pix_margeb - tr.pix_margeh) * proportion);
    }
    yym = tr.pix_margeb - rose_y;
    yyp = tr.pix_margeb;
    ctx.fillStyle = 'black';
    ctx.textBaseline = "bottom";
    ctx.font = my_fonts.principal;
    ctx.fillText("Heure locale (UTC -" + gdate_utc_offset / 60 + ")", tr.pix_margeg, yym - 2);
    for(irose = 0; irose < nroses; irose++){
        if (fcstind + irose == ni) break;
        // Tracer la boite
        ctx.beginPath();
        ctx.strokeStyle = 'black';
        xxm = tr.pix_margeg + irose * rose_x;
        xxp = xxm + rose_x;
        ctx.moveTo(xxm, yym);
        ctx.lineTo(xxp, yym);
        ctx.lineTo(xxp, yyp);
        ctx.lineTo(xxm, yyp);
        ctx.lineTo(xxm, yym);
        ctx.stroke();
        une_rose(fcstind + irose);
    }
    function une_rose(ind1) {
        var ltr = new Toutou_Transform();
        ltr.pix_margeg = xxm;
        ltr.pix_marged = xxp;
        ltr.pix_margeh = yym;
        ltr.pix_margeb = yyp;
        ltr.xmax = 100;
        ltr.xmin = 0;
        ltr.ymax = 100;
        ltr.ymin = 0;
        ltr.init();
        var range = 0.45 * (ltr.pix_marged - ltr.pix_margeg);
        var df = range / 6.;
        var dfd = range / 4;
        var dd = range / 2.181818;
        var longu = range - df;
        var radius = range / 6.;
        // tete de la fleche
        var tete = range / 6.;
        var tetel = range / 6. * .7;
        // corps de la fleche / 2
        var dl = tete * .35;
        var fl = range * .8;
        var xl = new Array(8);
        var yl = new Array(8);
        var xl2 = new Array(8);
        var yl2 = new Array(8);
        var xcenter = 0;
        var ycenter = 0;
        ctx.font = my_fonts.principal;
        ctx.fillStyle = "#33A";
        ctx.textAlign = "left";
        ctx.textBaseline = "top";
        datev.setHours(datev.getHours() + hhh[ind1]);
        dy = (ltr.pix_margeh - ltr.pix_margeb) * .08;
        // Jour date mois an
        ctx.fillText(' ' + toutou_xy_titre_principal(datev, 1), ltr.xmin_pix, ltr.ymax_pix);
        // heure
        ctx.fillText(' ' + toutou_xy_titre_principal(datev, 2) + ' heures', ltr.xmin_pix, ltr.ymax_pix - dy);
        datev.setHours(datev.getHours() - hhh[ind1]);
        // Direction
        ctx.fillText(' Direction ' + dir[ind1][0], ltr.xmin_pix, ltr.ymax_pix - 2 * dy);
        xcenter = ltr.pix_margeg + .5 * (ltr.pix_marged - ltr.pix_margeg);
        ycenter = ltr.pix_margeb - .5 * (ltr.pix_marged - ltr.pix_margeg);
        // les 4 branches en 45
        xl[0] = xcenter + dfd;
        xl[1] = xcenter + dd;
        xl[2] = xcenter;
        xl[3] = xcenter - dd;
        xl[4] = xcenter - dfd;
        xl[5] = xcenter - dd;
        xl[6] = xcenter;
        xl[7] = xcenter + dd;
        yl[0] = ycenter;
        yl[1] = ycenter + dd;
        yl[2] = ycenter + dfd;
        yl[3] = ycenter + dd;
        yl[4] = ycenter;
        yl[5] = ycenter - dd;
        yl[6] = ycenter - dfd;
        yl[7] = ycenter - dd;
        ctx.fillStyle = "#99F";
        toutou_polygone(ctx, xl, yl, 'filled');
        // les 4 branches du dessus
        xl[0] = xcenter + longu;
        xl[1] = xcenter + df;
        xl[2] = xcenter;
        xl[3] = xcenter - df;
        xl[4] = xcenter - longu;
        xl[5] = xcenter - df;
        xl[6] = xcenter;
        xl[7] = xcenter + df;
        yl[0] = ycenter;
        yl[1] = ycenter + df;
        yl[2] = ycenter + longu;
        yl[3] = ycenter + df;
        yl[4] = ycenter;
        yl[5] = ycenter - df;
        yl[6] = ycenter - longu;
        yl[7] = ycenter - df;
        ctx.fillStyle = "blue";
        toutou_polygone(ctx, xl, yl, 'filled');
        // X au centre de la rose
        ctx.strokeStyle = "#99F";
        toutou_line(ctx, xcenter - df, ycenter - df, xcenter + df, ycenter + df);
        toutou_line(ctx, xcenter - df, ycenter + df, xcenter + df, ycenter - df);
        var rafale = Math.max(gust[ind1], force[ind1][0]);
        vent_moyen = .5 * (force[ind1][0] + rafale);
        // Force
        ctx.fillStyle = "#33A";
        if (rafale > force[ind1][0]) ctx.fillText(' ' + Math.round(force[ind1][0]) + ' a ' + Math.round(rafale) + ' ' + uniteJson.unite, ltr.xmin_pix, ltr.ymax_pix - 3 * dy);
        else ctx.fillText(' ' + Math.round(force[ind1][0]) + ' ' + uniteJson.unite, ltr.xmin_pix, ltr.ymax_pix - 3 * dy);
        // Temperature
        ctx.fillStyle = "red";
        ctx.textAlign = "right";
        ctx.textBaseline = "bottom";
        ctx.fillText(Math.round(temp[ind1][0]) + ' C ', ltr.pix_marged, ycenter - longu - 1);
        // Precip
        ctx.fillStyle = "green";
        ctx.textAlign = "left";
        ctx.fillText(" " + Math.round(precip[ind1] * 10) / 10 + ' mm ', ltr.pix_margeg, ycenter - longu - 1);
        if (vent_moyen < 2.) {
            // Cercle noir
            ctx.beginPath();
            ctx.fillStyle = "black";
            ctx.arc(xcenter, ycenter, .4 * dd, 0, 2 * Math.PI, false);
            ctx.fill();
        } else {
            xl[0] = xcenter;
            xl[1] = xcenter - tetel;
            xl[2] = xcenter - dl;
            xl[3] = xcenter - dl;
            xl[4] = xcenter + dl;
            xl[5] = xcenter + dl;
            xl[6] = xcenter + tetel;
            xl[7] = xcenter;
            yl[0] = ycenter;
            yl[1] = ycenter + tete;
            yl[2] = ycenter + tete;
            yl[3] = ycenter + fl;
            yl[4] = ycenter + fl;
            yl[5] = ycenter + tete;
            yl[6] = ycenter + tete;
            yl[7] = ycenter;
            // Rotation
            angle = dir[ind1][0] * deg2rad;
            for(i = 1; i < 7; i++){
                xx = xl[i] - xcenter;
                yy = yl[i] - ycenter;
                rr = Math.sqrt(xx * xx + yy * yy);
                tetha = Math.acos(xx / rr);
                xl[i] = rr * Math.cos(tetha - angle) + xcenter;
                yl[i] = -rr * Math.sin(tetha - angle) + ycenter;
            }
            xl2[0] = xcenter;
            xl2[1] = xcenter - tetel;
            xl2[2] = xcenter - dl;
            xl2[3] = xcenter - dl;
            xl2[4] = xcenter + dl;
            xl2[5] = xcenter + dl;
            xl2[6] = xcenter + tetel;
            xl2[7] = xcenter;
            yl2[0] = ycenter;
            yl2[1] = ycenter + tete;
            yl2[2] = ycenter + tete;
            // Normaliser la longueur a 25 noeuds.
            tempo = Math.max(fl * vent_moyen / (25. * uniteJson.conv), fl * 5. / 25.);
            yl2[3] = ycenter + tempo;
            yl2[4] = ycenter + tempo;
            yl2[5] = ycenter + tete;
            yl2[6] = ycenter + tete;
            yl2[7] = ycenter;
            // Rotation
            for(i = 1; i < 7; i++){
                xx = xl2[i] - xcenter;
                yy = yl2[i] - ycenter;
                rr = Math.sqrt(xx * xx + yy * yy);
                tetha = Math.acos(xx / rr);
                xl2[i] = rr * Math.cos(tetha - angle) + xcenter;
                yl2[i] = -rr * Math.sin(tetha - angle) + ycenter;
            }
            ctx.fillStyle = "#AAA";
            toutou_polygone(ctx, xl, yl, 'filled');
            ctx.fillStyle = "red";
            toutou_polygone(ctx, xl2, yl2, 'filled');
            ctx.strokeStyle = "black";
            toutou_polygone(ctx, xl, yl);
        }
        ctx.font = my_fonts.legende;
        ctx.fillStyle = "black";
        ctx.textAlign = "right";
        ctx.textBaseline = "middle";
        ctx.fillText('O', xcenter - longu - 1, ycenter);
        ctx.textAlign = "left";
        ctx.fillText('E', xcenter + longu + 1, ycenter);
        ctx.textAlign = "center";
        ctx.textBaseline = "top";
        ctx.fillText('S', xcenter, ycenter + longu + 1);
        ctx.textBaseline = "bottom";
        ctx.fillText('N', xcenter, ycenter - longu - 1);
        ctx.textAlign = "right";
        ctx.fillText('no', xcenter - dd - 1, ycenter - dd);
        ctx.textBaseline = "top";
        ctx.fillText('so', xcenter - dd - 1, ycenter + dd);
        ctx.textBaseline = "bottom";
        ctx.textAlign = "left";
        ctx.fillText('ne', xcenter + dd + 1, ycenter - dd);
        ctx.textBaseline = "top";
        ctx.fillText('se', xcenter + dd + 1, ycenter + dd);
    }
}

//# sourceMappingURL=imeteo.2267e894.js.map
